import { render, staticRenderFns } from "./catalog-row.vue?vue&type=template&id=17bb7177"
import script from "./catalog-row.vue?vue&type=script&lang=js"
export * from "./catalog-row.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports